module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo01-1746aa8aae20f06ad3392bdf32f8b6d1.jpg";